
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import eventTrackingQdapMallFnMixins from '~/mixins/eventTrackingQdapMallFnMixins.js';
export default {
    name: "QdapHomeCaseStudySection",
    
    mixins: [eventTrackingMixins, eventTrackingQdapMallFnMixins],

    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            pageData: null,
            activeCatCode: '1',
            settings: {
                arrows: true,
                dots: true,
                adaptiveHeight: true,
                autoplay: false,
                lazyLoad: 'progressive',
                responsive: [],
                centerMode: true,
            },
        }
    },

    computed: {
        activeCards() {
            return this.data?.CaseStudyCard.filter(card => card.CategoryCode === this.activeCatCode);
        }
    },

    mounted() {
    },
    methods: {
        handleCatClicked(catCode, catText) {
            this.changeCatCode(catCode);
            this.handleEventTracking(catText);
        },
        changeCatCode(catCode) {
            try {
                this.activeCatCode = catCode;
            } catch (e) {
                console.error(e);
                this.$sentry.captureException(e);
            }
        },
        
        // #197 {button text}	go_to_case-study qdap_case-study_cta
        handleEventTracking(catText){
            const eventTrackingParams = this.initEventTrackingParams()
            eventTrackingParams.a = 'go_to_case-study' 
            eventTrackingParams.c = 'qdap_case-study_cta' 
            eventTrackingParams.l = catText
            
            this.sendEventTracking(eventTrackingParams)
        },

        initHandler() {
            if (!this.areResonsiveSettingsApplied) {
                this.settings.responsive = this.responsiveSettings;
                this.areResonsiveSettingsApplied = true;
            }
        },
    },
}
